import React, { useEffect } from 'react';
import { attachCashAppPay } from 'utilities/web_payment_sdk';

const CashAppPay = (props) => {
  const { cashAppPay, tokenize } = props;

  useEffect(() => {
    // Displays PwC button
    attachCashAppPay(cashAppPay);

    // for desktop (user approves via mobile cam), there is no redirect, handle `ontokenization` and call tokenize()
    // for mobile, the user will continue through to the cash app page/app and follow the redirectURL we provided
    //             that redirect will handle the call to create the payment, see: `cash_app.redirect.jsx`.
    cashAppPay.addEventListener(
      'ontokenization',
      ({ detail: { tokenResult } }) => {
        tokenize(tokenResult);
      },
    );
  }, [cashAppPay]);

  return (
    <>
      <div id="pay-with-cash-app" />
    </>
  );
};

export default CashAppPay;
